import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { utils, write } from 'xlsx';
import { saveAs } from 'file-saver';
import useHandleErrors from '../../utils/user.utils';
import * as XLSX from 'xlsx';
import moment from 'moment';
import Select from 'react-select';

export default function AssetInventory() {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [isDropdownOpen, setIsDropdownOpen] = useState(true);
    const handleErrors = useHandleErrors();
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const hasFetchedRef = useRef(false);
    const [assetId, setassetId] = useState('');

    const navigate = useNavigate();
    const token = localStorage.getItem("token");


    const [formData, setFormData] = useState({
        Status: "",
        AssetCondition: "",
        Comments: "",
    });

    const getAssetReport = async () => {
        setLoading(true);
        try {
            const path = "/getAssetReport";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 200) {
                const responseData = response.data.RegisterAssets || [];
                setData(responseData);
                setFilteredData(responseData);
            } else if (response.status === 404) {
                setData([]); // Set data to an empty array
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    setData([]); // Set data to an empty array
                } else {
                    handleErrors(error.response);
                }
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!hasFetchedRef.current) {
            getAssetReport()
            hasFetchedRef.current = true;
        }
    }, [isDropdownOpen]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCancel = (e) => {
        e.preventDefault();
        setFormData({
            Status: "",
            AssetCondition: "",
            Comments: "",
        });
    };


    const handleDropdownClick = (record) => {
        console.log("record", record)
        setassetId(record.AssetId)
    };

    useEffect(() => {
        const preloading = document.getElementById("preloading");
        setTimeout(() => {
            if (preloading) {
                preloading.style.display = "none";
            }
        }, 400);
    }, []);

    const assetConditionOptions = [
        { value: 'Good', label: 'Good' },
        { value: 'Bad', label: 'Bad' }
    ];

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'InActive', label: 'InActive' }
    ];

    const ClearIndicator = () => null;


    const handleSubmit = async (e) => {
        e.preventDefault();
        // setIsDropdownOpen(false);
        setLoading(true);

        if (!formData.Status) {
            toast.error("Status is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return
        }
        if (!formData.AssetCondition) {
            toast.error("Condition is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }

        const data = new FormData();
        Object.keys(formData).forEach((key) => {
            data.append(key, formData[key]);
        });
        data.append("AssetId", assetId)

        try {
            const path = "/updateRegisterAssets";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.put(URL, data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            if (response.status === 200) {
                toast.success("Asset Updated successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                getAssetReport();
                setFormData({
                    Status: "",
                    AssetCondition: "",
                    Comments: "",
                });
                setIsDropdownOpen(true)
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
            // Simulate click outside after a short delay
            setTimeout(() => {
                const outsideClickElement = document.createElement('div');
                document.body.appendChild(outsideClickElement);
                outsideClickElement.click();
                document.body.removeChild(outsideClickElement);
            }, 100); // Delay to ensure dropdown menu has time to render
        }
    };

    useEffect(() => {
        // Filter employees based on the search query
        setFilteredData(
            data.filter(asset =>
                asset.CategoryType.toLowerCase().includes(searchQuery.toLowerCase()) ||
                asset.AssetId.toLowerCase().includes(searchQuery.toLowerCase()) ||
                asset.SerialNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
                asset.AssetCondition.toLowerCase().includes(searchQuery.toLowerCase()) ||
                asset.Status?.toLowerCase().includes(searchQuery.toLowerCase().trim())
            )
        );
        console.log("first", data)
    }, [searchQuery, data]);



    const sendEmail = (email) => {
        // Excel generation logic
        const ws = utils.json_to_sheet(filteredData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Asset Inventory');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

        // Convert the Excel file to a Base64 string
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
            const base64data = reader.result.split(',')[1]; // Get the Base64 string without the prefix

            // Create a downloadable link for the attachment
            const link = document.createElement('a');
            link.href = reader.result;
            const today = new Date();
            const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
            const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
            const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
            const formattedDate = `${year}${month}${day}`;
            link.download = `WW360-Asset_Inventory_Report_${formattedDate}.xlsx`;

            // Simulate a click to download the attachment
            link.click();

            // Prepare the mailto link (without attachment)
            const subject = "Asset Inventory List";
            const body = 'Please find the attached file.';
            const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

            toast.info('The Excel file has been generated and downloaded. Please attach the file manually to your email.', {
                position: toast.POSITION.TOP_CENTER,
            });

            setTimeout(() => {
                window.location.href = mailtoLink;
            }, 3000);

        };
    };

    const shareData = {
        title: 'Asset Inventory List',
        text: 'Check out the Asset Inventory list',
        url: window.location.href
    };

    const handleShare = async () => {
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Asset Inventory");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const today = new Date();
        const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
        const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
        const formattedDate = `${year}${month}${day}`;
        saveAs(blob, `WW360-Asset_Inventory_Report_${formattedDate}.xlsx`);
    };

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredData.length / recordsPerPage);


    const paginate = pageNumber => setCurrentPage(pageNumber);

    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">Asset Inventory</h3>
                        </div>
                        <div className="col-auto">
                            <Link to={'/RegisterAsset'} className="btn btn-primary mt-lg-0 mt-4">
                                <i className="ri-add-circle-line"></i> Register New
                            </Link>
                        </div>
                    </div>
                    {data?.length === 0 ? (
                        <div class="container">
                            <div class="row vh-50 justify-content-center align-items-center">
                                <div class="col-auto">
                                    <div class="no-data-wrapper">
                                        <div class="no-data-found">
                                            <i class="ri-file-damage-fill"></i>
                                            <div class="bounce"><i class="ri-search-eye-line"></i></div>
                                            <p>No Data Found</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className="row align-items-center justify-content-center mb-4">
                                <div className="col-lg-5 col-md-8 col-sm-10">
                                    <div className="container-fluid row-rounded mb-0">
                                        <div className="row px-2 py-0">
                                            <div className="input-group mb-0">
                                                <input
                                                    type="search"
                                                    className="form-control search-input"
                                                    placeholder="Keyword search..."
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                />
                                                <div className="input-group-append">
                                                    <button className="btn btn-primary" type="button" title="Search" rel="tooltip">
                                                        <i className="ri-menu-search-line"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <small className="form-text text-muted text-center mt-0">
                                        <i className="ri-information-2-fill text-info"></i> Allows: CategoryType - AssetId - Serial Number - Asset Condition - Status
                                    </small>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card mb-4">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col">
                                                    <h5 className="title mt-1 mb-0">Asset Summary</h5>
                                                </div>
                                                <div className="col-auto">
                                                    <button
                                                        type="button"
                                                        title="Email"
                                                        rel="tooltip"
                                                        className="btn btn-light btn-circle ml-2"
                                                        onClick={() => sendEmail('')}
                                                    >
                                                        <i className="ri-mail-send-fill"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        title="Share"
                                                        rel="tooltip"
                                                        className="btn btn-light btn-circle ml-2"
                                                        onClick={handleShare}
                                                    >
                                                        <i className="ri-share-fill"></i>
                                                    </button>
                                                    <button type="button" title="Export" className="btn btn-light btn-circle ml-2" onClick={exportToExcel}>
                                                        <i className="ri-export-fill"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="row mt-3">

                                                <div className="col-md-12">
                                                    <div className="table-responsive asset-information">
                                                        <table className="table grid">
                                                            <thead className="bg-light">
                                                                <tr>
                                                                    <th>S.No.</th>
                                                                    <th>Category</th>
                                                                    <th>Asset ID</th>
                                                                    <th>Serial Number</th>
                                                                    <th>Registered Date</th>
                                                                    <th>Warranty End</th>
                                                                    <th>Condition</th>
                                                                    <th>Status</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentRecords.map((record, index) => (
                                                                    <tr key={record.AssetId}>
                                                                        <td>{index + 1 + indexOfFirstRecord}</td>
                                                                        <td>{record.CategoryType}</td>
                                                                        <td>{record.AssetId}</td>
                                                                        <td>{record.SerialNumber}</td>
                                                                        <td>{record.PurchaseDate ? moment(record.PurchaseDate).format("DD-MM-YYYY") : "N/A"}</td>
                                                                        <td>{record.WarrantyEndDate ? moment(record.WarrantyEndDate).format("DD-MM-YYYY") : "N/A"}</td>
                                                                        <td>{record.AssetCondition}</td>
                                                                        <td>
                                                                            {record.Status.trim().toLowerCase() === 'active' ? (
                                                                                <span className="badge border border-success text-success status">
                                                                                    <i className="ri-thumb-up-fill"></i> {record.Status.trim()}
                                                                                </span>
                                                                            ) : (
                                                                                <span className="badge border border-light text-light status">
                                                                                    <i className="ri-thumb-down-line"></i> Inactive
                                                                                </span>
                                                                            )}
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <div className="dropdown" key={record.AssetId}>
                                                                                <button
                                                                                    className="btn btn-link text-info btn-action custom-dropdown-btn dropdown-toggle"
                                                                                    type="button"
                                                                                    id={`dropdownMenuButton-${record.AssetId}`}
                                                                                    data-toggle="dropdown"
                                                                                    aria-haspopup="true"
                                                                                    aria-expanded="false"
                                                                                    title="Update"
                                                                                    onClick={() => handleDropdownClick(record)}
                                                                                >
                                                                                    <i className="ri-list-settings-line"></i>
                                                                                </button>
                                                                                {isDropdownOpen ? (
                                                                                    <div
                                                                                        className="dropdown-menu dropdown-menu-right custom-dropdown shadow"
                                                                                        aria-labelledby={`dropdownMenuButton-${record.AssetId}`}
                                                                                    >
                                                                                        <form className="row" onSubmit={handleSubmit}>
                                                                                            <div className="form-group col-12" onClick={(e) => e.stopPropagation()}>
                                                                                                <label htmlFor="assetStatus" className="required">Status</label>
                                                                                                <Select
                                                                                                     className="react-select-container"
                                                                                                    classNamePrefix="react-select"
                                                                                                    name="Status"
                                                                                                    value={statusOptions.find(option => option.value === formData.Status) || null}
                                                                                                    onChange={(selectedOption) => setFormData({ ...formData, Status: selectedOption ? selectedOption.value : '' })}
                                                                                                    options={statusOptions}
                                                                                                    placeholder="Select"
                                                                                                    isClearable
                                                                                                    components={{ ClearIndicator }}
                                                                                                    menuPortalTarget={document.body}
                                                                                                    styles={{
                                                                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                                        control: base => ({ ...base, zIndex: 1 })
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                            <div className="form-group col-md-12" onClick={(e) => e.stopPropagation()}>
                                                                                                <label htmlFor="assetCondition" className="required">Condition</label>
                                                                                                <Select
                                                                                                    className="react-select-container"
                                                                                                    classNamePrefix="react-select"
                                                                                                    name="AssetCondition"
                                                                                                    value={assetConditionOptions.find(option => option.value === formData.AssetCondition) || null}
                                                                                                    onChange={(selectedOption) => setFormData({ ...formData, AssetCondition: selectedOption ? selectedOption.value : '' })}
                                                                                                    options={assetConditionOptions}
                                                                                                    placeholder="Select"
                                                                                                    isClearable
                                                                                                    components={{ ClearIndicator }}
                                                                                                    menuPortalTarget={document.body}
                                                                                                    styles={{
                                                                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                                        control: base => ({ ...base, zIndex: 1 })
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                            <div className="form-group col-12">
                                                                                                <label htmlFor="Comments">Damage <small className="text-muted">(If any)</small></label>
                                                                                                <textarea
                                                                                                    id="Comments"
                                                                                                    name="Comments"
                                                                                                    className="form-control"
                                                                                                    rows="3"
                                                                                                    cols="5"
                                                                                                    value={formData.Comments}
                                                                                                    onChange={handleChange}
                                                                                                />
                                                                                            </div>
                                                                                            <div className="col-12 text-center">
                                                                                                <button type="reset" className="btn btn-light" onClick={handleCancel}>Reset</button>
                                                                                                <button type="submit" className="btn btn-primary">
                                                                                                    Update <i className="ri-checkbox-circle-line"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        </form>
                                                                                    </div>
                                                                                ) : null}
                                                                            </div>
                                                                        </td>

                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>

                                                <div className="col-md-12">
                                                    <div className="container-fluid">
                                                        <div className="row border-top pt-3">
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Records</p>
                                                            </div>
                                                            <div className="col-1 record-drop">
                                                                <select className="form-control" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                                    <option value="5">5</option>
                                                                    <option value="10">10</option>
                                                                    <option value="15">15</option>
                                                                    <option value="20">20</option>
                                                                    <option value="25">25</option>
                                                                </select>
                                                            </div>
                                                            <div className="col">
                                                                <nav>
                                                                    <ul className="pagination justify-content-center">
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-double-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage - 1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                                            <li key={index + 1} className={`page-item ${index + 1 === currentPage ? 'active' : ''}`}>
                                                                                <button className="page-link" onClick={() => paginate(index + 1)}>
                                                                                    {index + 1}
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                                                                                <i className="ri-arrow-right-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(totalPages)}>
                                                                                <i className="ri-arrow-right-double-fill"></i>
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                            </div>
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Page Showing {currentPage} of {totalPages}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

